// removed by extract-text-webpack-plugin
module.exports = {"container":"_9minF0upnZbbhlzzutz7P","inner":"_1tVevagOq-gsRAY6DoFlnS","icon":"_2Zw8k05bEkxu94VvJQ9_jB","error":"_3CSlaeaQRGYJfawCOXAd2c"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Auth/Layout/styles.css
// module id = 1010
// module chunks = 21